import { Box, Button, TextField, Typography, useTheme } from '@mui/material'
import { FC, FormEvent, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../../../../../../store'
import { CurrentUserActions, CurrentUserSelector } from '../../../../../../../../store/currentUser'
import { SnackbarActions } from '../../../../../../../../store/snackbar'
import { ValidationError } from '../../../../../../../../utils/helper'

export const AddCompanyMemberForm: FC<{ onClose: () => void }> = ({ onClose }) => {
  const dispatch = useDispatch<AppDispatch>()

  const loading = useSelector(CurrentUserSelector.isLoading)

  const [email, setEmail] = useState('')

  const handleAddMembers = async (e:FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    try {
      if (!email) {
        throw new ValidationError('please add the current email in list or remove it')
      }

      const inviteAction = await dispatch(
        CurrentUserActions.addCurrentUserCompanyMembersAsync({
          body: [email],
        }),
      )

      if (CurrentUserActions.addCurrentUserCompanyMembersAsync.fulfilled.match(inviteAction)) {
        dispatch(
          SnackbarActions.showSnackbar({
            message: 'invite email have sent successfully',
            options: { variant: 'success' },
          }),
        )
      }

      onClose()
    } catch (error: any) {
      dispatch(
        SnackbarActions.showSnackbar({
          message: error.message,
        }),
      )
    }
  }

  return (
    <Box sx={{ py:2 ,px:3 }}>
      <Typography mb={2} color="secondary" fontSize="1.2rem" fontWeight={600}>
        Add company member
      </Typography>

      <form autoComplete="off" onSubmit={handleAddMembers}>
        <Box>
          <Typography mb={1} color="secondary" fontSize="0.9rem" fontWeight={600}>
            Email
          </Typography>
          <TextField
            required
            fullWidth
            type="email"
            variant="outlined"
            placeholder='E.g johndoe@gmail.com'
            onChange={(e) => setEmail(e.target.value)}
          />
        </Box>

        <Button
          fullWidth
          type="submit"
          disableElevation
          variant="contained"
          disabled={loading}
          sx={{
            mt: 2,
            height: '42px',
            fontSize: '14px',
            borderRadius: '6px',
            textTransform: 'none',
          }}
        >
          Send invite
        </Button>
      </form>
    </Box>
  )
}
